import script from "./Audience.vue?vue&type=script&setup=true&lang=js"
export * from "./Audience.vue?vue&type=script&setup=true&lang=js"

import "./Audience.vue?vue&type=style&index=0&id=3bfd8c4c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfd8c4c"]])

export default __exports__